import { unavailableComputerModelMessage } from '#pplx/frontend/apps/ask/search-models-menu/ComputerModelAvailabilityMessages.js';
import { HarnessMode } from '#pplx/frontend/apps/ask/search-models-menu/ComputerPresetsShared.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { defineMessages } from 'react-intl';
export const messages = defineMessages({
    unavailableModel: unavailableComputerModelMessage,
    chooseAvailableModel: {
        defaultMessage: 'This saved model is unavailable. Choose another model or a preset.',
        description: 'Explanation shown when a saved custom Computer model is no longer available',
        id: '74bbf69c89',
    },
    lastResponseModel: {
        defaultMessage: 'The last response used {model}.',
        description: 'Actual model used for the last completed Computer response when the saved custom model is unavailable',
        id: '74d232accf',
    },
    default: {
        defaultMessage: 'Default',
        description: 'Label for the default option in the Computer (ASI) model menu',
        id: 'a5fbfe10d1',
    },
});
export const computerEffortControlInteractedEvent = EVENT_PAYLOAD;
export const canShowComputerPresets = ({ disabled = false, computerEffortPreferences, onComputerEffortPreferencesChange, onModelChange, selectedModel, selectedMode, }) => Boolean(computerEffortPreferences &&
    (disabled || onComputerEffortPreferencesChange) &&
    onModelChange &&
    selectedModel &&
    selectedMode === SearchMode.ASI);
//# sourceMappingURL=ComputerPresetsMenuShared.js.map